import type { Item, Highlight } from '@glideapps/glide-data-grid';

const getCellHighlight = ([colIndex, rowIndex]: Item): Highlight => ({
  color: 'hsl(40 90% 60% / 10%)',
  range: {
    x: colIndex,
    y: rowIndex,
    width: 1,
    height: 1,
  },
  style: 'dashed',
});

export const getHighlightedRegions = (regions: Item[]): Highlight[] =>
  regions.map(getCellHighlight);
